import React, { useState } from 'react';
import '../styles/About.css';

// SVG Icons for Roles and Requirements
const ShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="about-svg">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="about-svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const TargetIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="about-svg">
    <circle cx="12" cy="12" r="10"></circle>
    <circle cx="12" cy="12" r="6"></circle>
    <circle cx="12" cy="12" r="2"></circle>
  </svg>
);

const GraduationCapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="about-svg">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
    <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"></path>
  </svg>
);

const IdCardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="about-svg">
    <rect x="3" y="4" width="18" height="16" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
    <circle cx="8" cy="15" r="2"></circle>
    <line x1="13" y1="15" x2="17" y2="15"></line>
  </svg>
);

const HandshakeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="about-svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const AwardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="about-svg">
    <circle cx="12" cy="8" r="7"></circle>
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
  </svg>
);

const About = () => {
  const [activeSection, setActiveSection] = useState('historique');

  const sections = [
    { id: 'historique', title: 'HISTORIQUE DE L\'ASB' },
    { id: 'fondements', title: 'FONDEMENTS ET RÔLE DE L\'ASB' },
    { id: 'structure', title: 'STRUCTURATION ET FONCTIONNEMENT' },
    { id: 'militant', title: 'PLACE ET ROLE DU MILITANT ASB' }
  ];

  return (
    <div className="about">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <div className="badge-indicator"></div>
            <span>Union Générale des Étudiants Burkinabè</span>
          </div>
          <h1>Association des Scolaires Burkinabè à Dakar</h1>
          <p className="hero-subtitle">
            À LA DÉCOUVERTE DE L'ASB ET DU MILITANTISME ÉTUDIANT
           
          </p>
        </div>
      </div>

      {/* Navigation des sections */}
      <nav className="section-nav">
        <div className="nav-container">
          {sections.map(section => (
            <button
              key={section.id}
              className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => setActiveSection(section.id)}
            >
              {section.title}
            </button>
          ))}
        </div>
      </nav>

      {/* Contenu des sections */}
      <div className="sections-container">

        {/* Section Historique */}
        {activeSection === 'historique' && (
          <section className="content-section">
            <div className="section-header">
              <h2>HISTORIQUE DE L'ASB</h2>
              <div className="section-divider"></div>
            </div>

            <div className="content-grid">
              <div className="content-card">
                <h3>CONTEXTE DE CRÉATION</h3>
                <div className="timeline">
                  <div className="timeline-item">
                    <div className="timeline-year">1956</div>
                    <div className="timeline-content">
                      <p>Création sous le nom de <strong>Association des Scolaires Voltaïque à Dakar (ASV)</strong></p>
                    </div>
                  </div>
                </div>
                <ul className="context-list">
                  <li>Tensions après la seconde guerre mondiale</li>
                  <li>Luttes pour l'émancipation et l'indépendance des peuples</li>
                  <li>Section dynamique de l'Union Générale des Étudiants d'Afrique Occidentale</li>
                </ul>
              </div>

              <div className="content-card">
                <h3>ÉVOLUTION</h3>
                <div className="timeline">
                  <div className="timeline-item">
                    <div className="timeline-year">1960</div>
                    <div className="timeline-content">
                      <p>Membre Fondateur de l'UGEV devenu UGEB (27 juillet 1960)</p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-year">1966</div>
                    <div className="timeline-content">
                      <p>Influence extérieure sur la direction de l'ASV</p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-year">1978</div>
                    <div className="timeline-content">
                      <p>Adoption de la plateforme d'union au congrès</p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-year">1984</div>
                    <div className="timeline-content">
                      <p>Changement de nom suite au changement du nom du pays</p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-period">1992-2000</div>
                    <div className="timeline-content">
                      <p>Période de léthargie due aux Programmes d'Ajustements Structurels (PAS)</p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-year">2003</div>
                    <div className="timeline-content">
                      <p>Redynamisation sur recommandation du XXIème congrès de l'U.G.E.B (14 janvier)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Section Fondements et Rôle */}
        {activeSection === 'fondements' && (
          <section className="content-section">
            <div className="section-header">
              <h2>FONDEMENTS ET RÔLE DE L'ASB</h2>
              <div className="section-divider"></div>
            </div>

            <div className="content-grid">
              <div className="content-card foundation-card">
                <h3>ORIENTATION</h3>
                <div className="foundation-badges">
                  <span className="foundation-badge syndical">ORGANISATION SYNDICALE</span>
                  <span className="foundation-badge patriotique">PATRIOTIQUE</span>
                  <span className="foundation-badge revolutionnaire">RÉVOLUTIONNAIRE</span>
                </div>
              </div>

              <div className="content-card">
                <h3>PLATEFORME D'UNION</h3>
                <ul className="platform-list">
                  <li>Défendre les intérêts matériels et moraux de ses membres</li>
                  <li>Lutter pour l'amélioration des conditions de vie et d'études</li>
                  <li>Soutenir et populariser les luttes des masses populaires burkinabè</li>
                  <li>Soutenir les luttes révolutionnaires des peuples du monde</li>
                  <li>Donner une formation syndicale à ses membres</li>
                  <li>Mobiliser le maximum d'étudiants</li>
                </ul>
              </div>

              <div className="content-card">
                <h3>RÔLE DE L'ASB</h3>
                <div className="role-grid">
                  <div className="role-item">
                    <div className="role-icon defense"><ShieldIcon /></div>
                    <h4>Défense des intérêts</h4>
                    <p>Défense des intérêts matériels et moraux des étudiants</p>
                  </div>
                  <div className="role-item">
                    <div className="role-icon organization"><UsersIcon /></div>
                    <h4>Organisation</h4>
                    <p>Organiser les revendications étudiantes</p>
                  </div>
                  <div className="role-item">
                    <div className="role-icon representation"><TargetIcon /></div>
                    <h4>Représentativité</h4>
                    <p>Représentation des étudiants burkinabè</p>
                  </div>
                  <div className="role-item">
                    <div className="role-icon formation"><GraduationCapIcon /></div>
                    <h4>Formation</h4>
                    <p>L'ASB est une École de formation</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Section Structure et Fonctionnement */}
        {activeSection === 'structure' && (
          <section className="content-section">
            <div className="section-header">
              <h2>STRUCTURATION ET FONCTIONNEMENT</h2>
              <div className="section-divider"></div>
            </div>

            <div className="content-grid">
              <div className="content-card">
                <h3>STRUCTURATION</h3>
                <div className="structure-grid">
                  <div className="structure-item executive">
                    <h4>Comité Exécutif (CE)</h4>
                    <p>Organe dirigeant de l'association</p>
                  </div>
                  <div className="structure-item delegates">
                    <h4>Délégués ASB</h4>
                    <p>Représentants dans les différentes écoles</p>
                  </div>
                  <div className="structure-item commissions">
                    <h4>Commissions</h4>
                    <p>Commissions spécifiques et circonstancielles</p>
                  </div>
                  <div className="structure-item assembly">
                    <h4>Assemblée Souveraine</h4>
                    <p>La base de l'organisation</p>
                  </div>
                </div>
              </div>

              <div className="content-card">
                <h3>FONCTIONNEMENT</h3>
                <div className="principles">
                  <h4>Principes de fonctionnement :</h4>
                  <div className="principle-badges">
                    <span className="principle-badge">Centralisme démocratique</span>
                    <span className="principle-badge">Critique et autocritique</span>
                  </div>
                </div>
                <ul className="functioning-list">
                  <li>Rencontres ordinaires et extraordinaires du CE</li>
                  <li>Consultation permanente de l'assemblée souveraine via les AG</li>
                  <li>Organisation d'activités de formation, ludiques et sportives</li>
                  <li>Participation aux instances de l'UGEB</li>
                </ul>
              </div>
            </div>
          </section>
        )}

        {/* Section Place et Rôle du Militant */}
        {activeSection === 'militant' && (
          <section className="content-section">
            <div className="section-header">
              <h2>PLACE ET ROLE DU MILITANT ASB</h2>
              <div className="section-divider"></div>
            </div>

            <div className="content-grid">
              <div className="content-card militant-card">
                <h3>LE MILITANT MODÈLE</h3>
                <div className="militant-requirements">
                  <div className="requirement-item">
                    <div className="requirement-icon membership"><IdCardIcon /></div>
                    <div className="requirement-content">
                      <h4>Adhésion formelle</h4>
                      <p>Achat de la carte de membre et paiement des cotisations</p>
                    </div>
                  </div>
                  <div className="requirement-item">
                    <div className="requirement-icon support"><HandshakeIcon /></div>
                    <div className="requirement-content">
                      <h4>Soutien institutionnel</h4>
                      <p>Accompagnement et mobilisation derrière le Comité Exécutif</p>
                    </div>
                  </div>
                  <div className="requirement-item">
                    <div className="requirement-icon participation"><TargetIcon /></div>
                    <div className="requirement-content">
                      <h4>Participation active</h4>
                      <p>Présence aux AG et activités de l'association</p>
                    </div>
                  </div>
                  <div className="requirement-item">
                    <div className="requirement-icon ambassador"><AwardIcon /></div>
                    <div className="requirement-content">
                      <h4>Ambassadeur des valeurs</h4>
                      <p>Représentation des valeurs promues par l'ASB</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default About;